export default {
  3008: "Olá, a chamada ainda não começou mas você pode esperar aqui até que ela inicie.",
  4003: "Falha ao entrar na chamada"
};
